export default __webpack_public_path__ + "static/media/Step2B.fd0f7811.svg";